import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function WholesaleCTABand() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-brand-700 via-brand-600 to-secondary-700">
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.3'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div ref={ref} className={`container-page relative z-10 scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-paper-50 mb-4">
            Ready to Trade at Scale?
          </h2>
          <p className="text-brand-100/80 max-w-xl mx-auto mb-8 text-sm md:text-base">
            Whether you&apos;re buying for a hotel chain or selling from a processing facility — Freshhlock Wholesale connects you to verified partners across India.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Apply as a Buyer
            </Link>
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-secondary-500 hover:bg-secondary-400 text-paper-50 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Apply as a Supplier
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}